import { z } from 'zod';

/**
 * Where a languages conversation came from, when it is about something the
 * learner brought from another part of speak: a chapter of the Audioteca
 * (`listen`), a news article (`news`) or Órbitas cards (`orbit`). Written by
 * the languages runtime into `voice_sessions.metadata.origin` at session start,
 * only when the content RESOLVED (a hint that degraded to plain free talk
 * leaves no origin: that conversation is free talk). Read by the history to
 * tell those conversations apart from plain free talk.
 *
 * Role-plays (`scenarioId`) and Program sessions (`mode: 'plan'`) are told
 * apart by their own fields; this covers what free talk carries in.
 */
export const sessionOriginSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('listen'),
    /** The book's title. */
    title: z.string().min(1),
    /** The chapter the learner listened to. */
    detail: z.string().min(1),
  }),
  z.object({
    kind: z.literal('news'),
    /** The article's headline. */
    title: z.string().min(1),
  }),
  z.object({
    kind: z.literal('orbit'),
    /** The first card's title (Spanish, as the learner read it). */
    title: z.string().min(1),
  }),
]);

export type SessionOrigin = z.infer<typeof sessionOriginSchema>;
